import React from "react";
import logo from "../assets/logo.jpg";
import { FaSearch } from "react-icons/fa";
import "../Styles/header.css";

const Header = () => {
  return (
    <div className="headerWrapper">
      <nav className="headerContainer">
        <a href="/html">
          <img src={logo} alt="Logo" />
        </a>
        <a href="/css/">Health Tips</a>
        <a href="/js/">Vaccination</a>
        <a href="/python/">Emotional Support</a>
        <a href="/#">Emergency Response</a>
        <a href="/#">Stress Relief</a>
        <a href="/#">First Aid Tips</a>

        <a href="/#">
          <FaSearch />
        </a>

        <a
          href="/#"
          style={{
            backgroundColor: "#FFA500CC",
            width: "100px",
            height: "30px",
            textAlign: "center",
            borderRadius: "10px",
          }}
        >
          Login
        </a>
      </nav>
    </div>
  );
};

export default Header;
